import { lazy } from 'react'

export const TanStackQueryDevToolsWrapper =
  "production" === 'production'
    ? () => null
    : lazy(() =>
        import('@tanstack/react-query-devtools').then((res) => ({
          default: res.ReactQueryDevtools
        }))
      )
